export const EnumStatus = Object.freeze({
  EMPTY: { status: 'EMPTY', statusValue: 'Trống' },
  BUSY: { status: 'BUSY', statusValue: 'Bận' },
  COMBINE: { status: 'COMBINE', statusValue: 'Bàn gộp' },
  BOOKED: { status: 'BOOKED', statusValue: 'Đặt trước' },
})
